import React from 'react';
import { Button } from './ui/button';
import { ArrowDown } from 'lucide-react';

const Hero = () => {
  const scrollToPortfolio = () => {
    document.getElementById('portfolio')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="relative h-screen w-full overflow-hidden">
      {/* Video Background */}
      <div className="absolute inset-0 z-0">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
        >
          <source
            src="https://customer-assets.emergentagent.com/job_oahu-photo-book/artifacts/mfi9an4v_b205e623-c159-40e0-ba5c-c71b8001ff25.mp4"
            type="video/mp4"
          />
        </video>
        {/* Overlay for better text readability */}
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900/60 via-slate-900/40 to-slate-900/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center text-white px-4 pt-40">
        <div className="text-center max-w-4xl mx-auto">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-2 sm:mb-3 tracking-tight leading-tight px-4">
            Private Photography Services
          </h1>
          <p className="text-base sm:text-lg md:text-xl lg:text-2xl mb-3 sm:mb-4 text-cyan-100 font-light">
            Capturing Life's Most Beautiful Moments
          </p>
          <p className="text-sm sm:text-base md:text-lg mb-6 sm:mb-10 text-slate-200 max-w-2xl mx-auto px-4">
            Specializing in beach weddings, family portraits, and artistic photography on Oahu's stunning shores
          </p>
          
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center mb-12 sm:mb-16 px-4">
            <Button
              size="lg"
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              className="w-full sm:w-auto bg-gradient-to-r from-cyan-500 to-teal-500 hover:from-cyan-600 hover:to-teal-600 text-white px-6 sm:px-8 py-5 sm:py-6 text-base sm:text-lg shadow-xl transition-all duration-300 hover:shadow-2xl hover:scale-105"
            >
              Get In Touch
            </Button>
            <Button
              size="lg"
              variant="outline"
              onClick={scrollToPortfolio}
              className="w-full sm:w-auto border-2 border-white/80 text-white hover:bg-white/20 backdrop-blur-sm px-6 sm:px-8 py-5 sm:py-6 text-base sm:text-lg transition-all duration-300"
            >
              View Portfolio
            </Button>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <ArrowDown className="w-8 h-8 text-white/70" />
        </div>
      </div>
    </div>
  );
};

export default Hero;
